import CampaignSpecialPricing from './components/CampaignSpecialPricing';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import get from 'lodash/get';
import { connect } from 'react-redux';

import {
  updateCampaign ,
  loadAgency,
  loadBrand,
  loadCampaign
} from '../../shared/redux/entities/actions';

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT,
  ADJOY_DEFAULT_QA_COST,
  ADJOY_DEFAULT_PUZZLE_COST
} from '../../config';

function mapStateToProps(state,props){
  const campaignId = props.campaignId,
    brandId = get(state,['entities','campaigns',campaignId,'companyId']),
    agencyId = get(state,['entities','campaigns',campaignId,'agencyId']),
    brand = get(state,['entities','companies',brandId],{}),
    agency = get(state,['entities','agencies',agencyId],{});

  return {
    campaignId:campaignId,
    brandId:brandId,
    agencyId:agencyId,
    campaignStatus:get(state,['entities','campaigns',campaignId,'status']),
    isEditable:get(state,['entities','campaigns',campaignId,'status']) === 'draft',
    chooseDefaultCost:get(state,['entities','campaigns',campaignId,'chooseCost']),
    defaultChooseDefaultCost:brand.chooseDefaultCost || agency.chooseDefaultCost || ADJOY_DEFAULT_CHOOSE_COST,
    ratableDefaultCost:get(state,['entities','campaigns',campaignId,'ratableCost']),
    defaultRatableDefaultCost:brand.ratableDefaultCost || agency.ratableDefaultCost || ADJOY_DEFAULT_RATABLE_COST,
    defaultRevenueSplit:get(state,['entities','campaigns',campaignId,'revenueSplit']),
    defaultDefaultRevenueSplit: brand.defaultRevenueSplit || agency.defaultRevenueSplit || ADJOY_DEFAULT_REVENUE_SPLIT,
    thisOrThatDefaultCost:get(state,['entities','campaigns',campaignId,'thisOrThatCost']),
    defaultThisOrThatDefaultCost:brand.thisOrThatDefaultCost || agency.thisOrThatDefaultCost || ADJOY_DEFAULT_THIS_OR_THAT_COST,
    qaDefaultCost:get(state,['entities','campaigns',campaignId,'qaCost']),
    defaultQADefaultCost:brand.qaDefaultCost || agency.qaDefaultCost || ADJOY_DEFAULT_QA_COST,
    puzzleDefaultCost:get(state,['entities','campaigns',campaignId,'puzzleCost']),
    defaultPuzzleDefaultCost:brand.puzzleDefaultCost || agency.puzzleDefaultCost || ADJOY_DEFAULT_PUZZLE_COST,
    costPerCompletion:get(state,['entities','campaigns',campaignId,'costPerCompletion'],0),
    useCostPerCompletion:get(state,['entities','campaigns',campaignId,'useCostPerCompletion'],false)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadBrand,
    loadAgency,
    loadCampaign,
    updateCampaign
  },dispatch);
}



export default withRouter(connect(mapStateToProps,mapDispatchToProps)(CampaignSpecialPricing));



// WEBPACK FOOTER //
// ./src/routes/CampaignSpecialPricing/index.js